export const cmToFeet = (cm) => {
  if (!cm) return '';
  const inches = Math.round(cm / 2.54);
  return `${Math.floor(inches / 12)}' ${inches % 12}"`;
};

// 4'6" → 7'0" in one-inch steps.
export const HEIGHTS = Array.from({ length: 31 }, (_, i) => {
  const inches = 54 + i;
  return { cm: Math.round(inches * 2.54), label: `${Math.floor(inches / 12)}' ${inches % 12}"` };
});

export const inr = (n) => (n || n === 0 ? `₹${Number(n).toLocaleString('en-IN')}` : '');

export const lakhLabel = (amount, period) => {
  if (!amount) return '';
  const yearly = period === 'monthly' ? amount * 12 : amount;
  const l = yearly / 100000;
  return `₹${l % 1 ? l.toFixed(1) : l} Lakh / yr`;
};

export function timeAgo(date) {
  if (!date) return '';
  const s = Math.max(1, Math.round((Date.now() - new Date(date)) / 1000));
  if (s < 60) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

export const clock = (date) => new Date(date).toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' });

export const toDateInput = (d) => (d ? new Date(d).toISOString().slice(0, 10) : '');

export const firstWord = (name = '') => name.replace(/^Dr\.\s*/, '').split(' ')[0];

export const initials = (name = '') =>
  name
    .replace(/^Dr\.\s*/, '')
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

export const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
};

// Keeps an imported value selectable even when it isn't in our option list.
export const withOption = (list = [], v) => (v && !list.includes(v) ? [v, ...list] : list);
